export default "__VITE_ASSET__DLWRoAzl__"